import axios from 'axios';

export const getSettings = async settings => {
	return axios({
		method: 'POST',
		url: process.env.VUE_APP_API_URI3 + '/settings',
		data: {
			settings,
		},
	});
};

export const getPublicSettings = async settings => {
	return axios({
		method: 'POST',
		url: process.env.VUE_APP_API_URI3 + '/public_settings',
		data: {
			settings,
		},
	});
};

export const updateSettings = async settings => {
	return axios({
		method: 'PUT',
		url: process.env.VUE_APP_API_URI3 + '/settings',
		data: {
			settings,
		},
	});
};
